import React, { useRef, useState, useLayoutEffect, useContext } from "react"
import useComponentSize from "@rehooks/component-size"
import { Link } from "react-router-dom"
import { useNavigateToPost } from "../../hooks/useNavigateToPost"
import { SmartDateFormat } from "../../util/dates"
import { AspectRatio, PlayCircle } from "react-bootstrap-icons"
import FreeTextFormat from "../shared/FreeTextFormat"
import CommentSectionPreview from "../comments/CommentSectionPreview"
import { PostListItemStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import HeadlinePostForm from "../HeadlinePostForm"
import { UserContext } from "@components/HomeApp"

export const VideoListItem = ({ video, updateStatus, adminMode = false }) => {
  const [postStatus, setPostStatus] = useState(video.status)
  const [currentHeadline, setCurrentHeadline] = useState(video)
  const [height, setHeight] = useState(0)
  const navigateToPostScreen = useNavigateToPost(video.nada_path)
  const [showEditForm, setShowEditForm] = useState(false)
  const { user } = useContext(UserContext)

  const ref = useRef(null)
  let size = useComponentSize(ref)

  useLayoutEffect(() => {
    setHeight(size.height)
  })

  const containerStyle = {
    height,
    position: "relative",
  }

  const playBtnStyle = {
    "color": "white",
    "position": "absolute",
    "aspect-ratio": "16 / 9",
    "object-fit": "cover",
  }

  return showEditForm ? (
    <HeadlinePostForm
      bandId={user.band_id}
      setShowForm={setShowEditForm}
      post={video}
      setNewPost={setCurrentHeadline}
    />
  ) : (
    <div className="grid grid-cols-12">
      <div
        className={clsx(
          PostListItemStyles.contentDiv,
          "flex justify-center items-center",
        )}
        style={containerStyle}
      >
        <img
          ref={ref}
          src={video.external_photo_src}
          width="100%"
          height="auto"
          title={video.title_cleaned}
          alt={video.title_cleaned}
          className="cursor-pointer"
          style={playBtnStyle}
          onClick={navigateToPostScreen}
        />
        <PlayCircle
          className="cursor-pointer"
          style={playBtnStyle}
          size="64"
          onClick={navigateToPostScreen}
        />
      </div>
      <div className={PostListItemStyles.metaDiv}>
        <PremiereHeader post={video} size="small" />
        <div className="flex items-start justify-between">
          <div>
            <h2
              className={clsx(
                PostListItemStyles.header,
                video.title.length > 100
                  ? PostListItemStyles.headerLong
                  : PostListItemStyles.headerShort,
                "cursor-pointer",
                video.is_bn_premiere && styles.premiereTitle,
              )}
              onClick={navigateToPostScreen}
            >
              <FreeTextFormat
                text={
                  video.title
                    ? video.title_cleaned || video.title
                    : `New Headline from ${video.band_name}`
                }
                expandable={false}
                expanded={false}
                linkify={true}
              />
            </h2>
          </div>
          <ShareUrlButton nadaUrl={video.nada_url} renderMode="icon" />
        </div>
        <Link className={PostListItemStyles.bandName} to={video.local_path}>
          {video.band_name}
        </Link>
        <h3 className={PostListItemStyles.postDate}>
          Released:&nbsp;
          {SmartDateFormat({ dateStr: video.published_at, includeTime: false })}
        </h3>
        {video.view_on && (
          <div className={PostListItemStyles.externalLink}>
            <a href={video.external_url} target="_blank" rel="noreferrer">
              view on&nbsp;
              {video.view_on}
            </a>
          </div>
        )}
        <div className={PostListItemStyles.description}>
          <FreeTextFormat text={video.description} expandable={false} />
        </div>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}
        <div className="mt-4">
          <RelatedPosts postId={video.id} />
        </div>
        <div className="mt-6">
          <ReactionBlock
            contentType="Post"
            contentId={video.id}
            postId={video.id}
          />
        </div>

        <CommentSectionPreview
          postId={video.id}
          postPath={video.nada_url}
        />
      </div>
    </div>
  )
}
